module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAUCAMAAABGQsb1AAAAgVBMVEUAAADcuXTYun/evXvdunzbvn3bu33evXvbu3vevH3avH7bvX7bvX7Yu33Zvn3cvn3cvH7avX3bvnzbvH3avXvcvX3bvX3bvX3bvX3bvH3bvX3bvX3cvH3avX3bvX3cvn3bvX3bvX3bvX3bvX3avXzbvX3bvH3bvX3bvXzbvX3bvX2xmk8NAAAAKnRSTlMAFhofJSsxNjg9RU1VVl5eZ2hxcnx8zNDW2tzh5uvt7vH09/n6+/39/v6x5DhnAAAAdUlEQVQoz43RWRKCUAxE0VZQQFFwRHBERfTuf4EswJhn/56qVJKW/ktyAa6pjdkNOE9tnLXAaWLj/A4cYxvzB9BENi474DC2sXwB1cjG9Rug3n9H0vbDr0jauaqNN1la9c5WUuFdJC2ezjcCnwy0EGgw0L6ZAYqpGQIRoj2EAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_left.png
// module id = ywxu
// module chunks = 11